import { useEffect, useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/shared/components/ui/dialog";
import { Button } from "@/shared/components/ui/button";
import { Trash2 } from "lucide-react";
import t from "@/lang/lang";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";
import { CommonDialogFooter } from "@/shared/components/dialog/dialog-common";
import { useHtzAirHandlingUnitDeleteMutation } from "@/services/backend/htz/ahu/api/ahu-api";

export function DeleteAhuDialog({
  airHandlingUnitId,
  onSuccess,
}: {
  airHandlingUnitId: string;
  onSuccess?: () => void;
}) {
  const [open, setOpen] = useState(false);
  const [del, { isLoading, error, isSuccess, reset }] =
    useHtzAirHandlingUnitDeleteMutation();

  const doDelete = () => {
    if (isLoading) return;
    del({ id: airHandlingUnitId });
  };

  useEffect(() => {
    if (isSuccess) {
      reset();
      setOpen(false);
      onSuccess?.();
    }
  }, [isSuccess, onSuccess, reset]);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button size="sm" variant="destructive">
          <Trash2 />
        </Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t("RLT-Anlage löschen?")}</DialogTitle>
          <DialogDescription>
            {t(
              "Die Anlage kann nur gelöscht werden, wenn keine Daten mehr von ihr abhängen. Wenn bereits Dokumente (Arbeitsscheine, Berichte) existieren, welche sich auf diese Anlage beziehen, kann sie nicht gelöscht werden.",
            )}
          </DialogDescription>
        </DialogHeader>
        <RTKQueryErrorAlert error={error} />
        <CommonDialogFooter
          isLoading={isLoading}
          onClickAction={doDelete}
          actionLabel={t("Löschen")}
          destructive
        />
      </DialogContent>
    </Dialog>
  );
}
